<template>
  <v-card elevation="0" class="rounded-lg px-5 py-3 ma-0 h-100">
    <v-row no-gutters>
      <v-col cols="12">
        <h4>{{  textValue}}</h4>
        <h5 class="font-weight-light text-capitalize">
          <b> {{ text }}</b>
        </h5>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    text: {
      required: true,
    },
    textValue: {
      required: true,
    },
  },
};
</script>